<template>
  <v-dialog v-model="dialog.active" persistent width="500">
    <v-card v-if="loading">
      <v-card-title class="headline">{{
        $t("components.dialogs.uploadFileDialog.uploadingFile")
      }}</v-card-title>
      <v-row no-gutters>
        <v-progress-circular
          class="mx-auto mb-3 mt-3"
          :size="55"
          :width="4"
          color="primary"
          indeterminate
        />
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close('close')" text
          >{{ $t("components.dialogs.uploadFileDialog.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="error.active && !loading">
      <v-card-title class="headline"
        >{{ $t("components.dialogs.uploadFileDialog.error") }}
      </v-card-title>
      <v-card-text>{{ error.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close('close')" text
          >{{ $t("components.dialogs.uploadFileDialog.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="!loading && !error.active && !visibilitySelected">
      <v-card-title class="headline"
        >{{ $t("components.dialogs.uploadFileDialog.previewData") }}
      </v-card-title>
      <v-list class="ml-2 pb-0 mb-0">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{
                $t(
                  "components.dialogs.uploadFileDialog.itemsInYourUploadedDocument",
                  { items: getLengthOfArrays }
                )
              }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="getNewItemsLength !== 0">
              {{
                $t(
                  "components.dialogs.uploadFileDialog.newItemsWillBeImportedToTheDatabase",
                  { items: getNewItemsLength }
                )
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="getItemsToBindLength !== 0">
              {{
                $t(
                  "components.dialogs.uploadFileDialog.itemsWillBeAddedToBoat",
                  { items: getItemsToBindLength }
                )
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="getDuplicateItemsLength !== 0">
              {{
                $t(
                  "components.dialogs.uploadFileDialog.duplicateItemsWillNotImported",
                  { items: getDuplicateItemsLength }
                )
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row no-gutters class="ml-2">
        <v-col cols="12">
          <v-list
            v-for="(groupedItems, groupedItemsIndex) in getAllItems"
            :key="groupedItemsIndex"
            class="pt-0 pb-0"
          >
            <v-list-item
              v-for="(item, index) in groupedItems.count"
              :key="index"
            >
              <v-list-item-content>
                <span class="subtitle-2" v-if="groupedItems.is_new"
                  >{{ $t("components.dialogs.uploadFileDialog.new") }}
                </span>
                <span
                  class="subtitle-2"
                  v-if="groupedItems.duplicate_items > index"
                  >{{
                    $t(
                      "components.dialogs.uploadFileDialog.notImportedDuplicate"
                    )
                  }}
                </span>
                <v-list-item-title>{{ groupedItems.name }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{ $t("components.dialogs.uploadFileDialog.sku") }}
                  {{ groupedItems.sku }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list class="mt-0 pt-0" v-if="hideShowMore">
            <v-list-item
              v-for="(item, index) in getCategoryNoneItems"
              :key="index"
            >
              <v-list-item-content>
                <span class="subtitle-2"
                  >{{
                    $t(
                      "components.dialogs.uploadFileDialog.notImportedCategoryIsNone"
                    )
                  }}
                </span>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{ $t("components.dialogs.uploadFileDialog.sku") }}
                  {{ item.sku }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-row no-gutters>
          <v-col cols="12">
            <v-row align="start" justify="center" no-gutters>
              <v-card-actions>
                <v-btn
                  v-if="!hideShowMore && getLengthOfArrays > 5"
                  text
                  color="primary"
                  @click="showMore(true)"
                  ><v-icon class="mx-2">mdi-eye</v-icon
                  >{{ $t("components.dialogs.uploadFileDialog.showAll") }}({{
                    getLengthOfArrays
                  }})</v-btn
                >
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close('close')" text
          >{{ $t("components.dialogs.uploadFileDialog.cancel") }}
        </v-btn>
        <v-btn color="primary" @click="save" text
          >{{ $t("components.dialogs.uploadFileDialog.import") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import api from "@/utils/api";
export default {
  props: ["dialog", "isEditView", "boatItems"],
  data() {
    return {
      groupRule: [],
      loading: true,
      visibilitySelected: null,
      changeBrand: null,
      hideShowMore: false,
      error: { text: "", active: false },
      getCategoryNoneItems: [],
      categoryNoneItems: [],
      allItemsGrouped: [],
      customItems: [],
      getAllItems: [],
      itemsToCreate: [],
      getItemsToCreate: [],
      getDuplicateItemsLength: 0,
    };
  },
  created() {
    this.setInitialData();
    if (this.isEditView) {
      api
        .getBoatItems(this.$route.params.id, "disable_pagination=true")
        .then((resp) => {
          this.customItems = resp.data;
          let filteredBoatItems = this.boatItems.filter(
            (item) => typeof item.special === "undefined"
          );
          this.concatBoatItems(filteredBoatItems);
          this.upload();
        });
    } else {
      this.visibilitySelected = false;
      this.loading = false;
      this.customItems = this.boatItems.filter(
        (item) => typeof item.special === "undefined"
      );

      api.groupsAutocomplete("").then((resp) => {
        var superGroup = resp.data.find((item) => item.is_supergroup);
        typeof superGroup !== "undefined"
          ? ((this.changeBrand = superGroup.uuid), this.upload())
          : (this.error.active = true);
        this.error.text = this.$t(
          "components.dialogs.uploadFileDialog.dontHavePermissionForImport"
        );
      });
    }
  },

  computed: {
    getLengthOfArrays() {
      return this.allItemsGrouped.reduce((acc, curr) => {
        return acc + curr.count;
      }, 0);
    },
    getNewItemsLength() {
      return this.itemsToCreate.length;
    },
    getItemsToBindLength() {
      return (
        this.getLengthOfArrays -
        this.getNewItemsLength -
        this.getDuplicateItemsLength
        // this.getNotToImportItemsLength -
      );
    },
    //REMOVED ON BACKEND
    // getNotToImportItemsLength() {
    //   return this.categoryNoneItems.length;
    // },
  },
  methods: {
    setInitialData() {
      this.groupRule = [
        (v) =>
          !!v || this.$t("components.dialogs.uploadFileDialog.groupIsRequired"),
      ];
    },
    upload(status) {
      const handleUpload = (resp) => {
        this.allItemsGrouped = resp.data.all_items_grouped;
        this.itemsToCreate = resp.data.items_to_create;
        this.categoryNoneItems = resp.data.category_none_items;
        this.showMore(false);
      };

      this.loading = true;

      let formData = new FormData();
      formData.append("file", this.dialog.file, this.dialog.file.name);
      status !== "save"
        ? formData.append("save", false)
        : formData.append("save", true);

      if (!this.isEditView) {
        this.visibilitySelected = false;
        api
          .uploadCsvFileNewBoat(this.changeBrand, formData, status)
          .then((resp) => {
            if (status !== "save") {
              handleUpload(resp);
              this.calculateStats(resp);
              this.loading = false;
            } else if (status === "save") {
              this.concatBoatItems(resp.data);
              this.close(this.customItems);
            }
          })
          .catch((err) => {
            this.handleError(err.response);
          });
      } else if (this.isEditView) {
        api
          .uploadCsvFileEditBoat(this.$route.params.id, formData, status)
          .then((resp) => {
            if (status !== "save") {
              handleUpload(resp);
              this.calculateStats(resp);
              this.loading = false;
            } else if (status === "save") {
              this.concatBoatItems(resp.data);
              this.close(this.customItems);
            }
          })
          .catch((err) => {
            this.handleError(err.response);
          });
      }
    },
    handleError(err, text) {
      this.loading = false;
      this.error.active = true;
      if (typeof err !== "undefined" && typeof text === "undefined") {
        if (err.status === 500 || err.status === 400) {
          this.error.text = this.$t(
            "components.dialogs.uploadFileDialog.uploadHasFailed"
          );
        } else if (typeof text === "undefined" && err.status === 403) {
          this.error.text = this.$t(
            "components.dialogs.uploadFileDialog.youDoNotHavePermissionToUploadFile"
          );
        }
      } else {
        this.error.text = text;
      }
    },

    concatBoatItems(resp) {
      let boatItemTemplate = () => {
        return {
          extended_warranty_months: null,
          serial_number: "",
          warranty_months: null,
          warranty_start_date: null,
          action: "created",
        };
      };

      resp.forEach((importedItem, index) => {
        let customItemIndex = this.customItems.findIndex((customItem) => {
          return customItem.sku === importedItem.sku;
        });

        if (customItemIndex === -1) {
          importedItem.action = "created";
          importedItem.boat_items.forEach((item) => {
            item.action = "created";
          });
          this.customItems.push(importedItem);
          return;
        }

        if (
          importedItem.count !==
          this.customItems[customItemIndex].boat_items.length
        ) {
          let index = Math.max(
            importedItem.count -
              this.customItems[customItemIndex].boat_items.length,
            0
          );

          for (let i = 0; i < index; i++) {
            this.customItems[customItemIndex].boat_items.push(
              boatItemTemplate()
            );
          }
        }
      });
    },

    calculateStats(resp) {
      this.getDuplicateItemsLength = 0;

      resp.data.all_items_grouped.forEach((importedItem, index) => {
        let customItemIndex = this.customItems.findIndex((customItem) => {
          return customItem.sku === importedItem.sku;
        });

        if (customItemIndex === -1) {
          return;
        }

        let currMin = Math.min(
          importedItem.count,
          this.customItems[customItemIndex].boat_items.length
        );

        importedItem.duplicate_items = currMin;
        this.getDuplicateItemsLength += currMin;
      });
    },

    showMore(status) {
      if (status) {
        this.getAllItems = this.allItemsGrouped;
        this.getItemsToCreate = this.itemsToCreate;
        this.getCategoryNoneItems = this.categoryNoneItems;
        this.hideShowMore = true;
      } else {
        this.getAllItems = this.allItemsGrouped.slice(0, 10);
        this.getItemsToCreate = this.itemsToCreate.slice(0, 10);
        this.getCategoryNoneItems = this.categoryNoneItems.slice(0, 10);
      }
    },

    close(status) {
      this.$emit("close", status);
    },
    save() {
      this.upload("save");
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
